// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui'
import '../static/css/element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import http from '../src/utils/http'
import utils from '../src/utils/utils'

import './assets/font_4062557_f39a0tmajrs/iconfont.css'
import pageheader from '../src/components/pageheader/pageheader'
Vue.component('pageheader',pageheader)

import {message} from './utils/resetmessage'

Vue.config.productionTip = false

axios.defaults.withCredentials = false

Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.http = http
Vue.prototype.utils = utils
Vue.use(ElementUI)
Vue.prototype.$message = message;

// import { message } from 'element-ui';
router.beforeEach((to, from, next) => {
  var user = localStorage.user ? JSON.parse(localStorage.user) : '';
  var token = localStorage.token ? JSON.parse(localStorage.token) : '';
  // var user = store.state.user;
  store.dispatch('setuser',user);//使用dispatch调用actions中定义的方法
  // document.title = to.meta.title
  // next()
  // return
  if (token) { // 判断是否有token
    // if (to.meta.roles && to.meta.roles.indexOf(user.role) === -1) {//页面有权限要求但用户不符合
    // 	message.error('您没有此页面访问的权限！');
    // 	if(from.path == '/login'){
    //     document.title = to.meta.title
    // 		next('/')
    // 	}else{
    //     document.title = to.meta.title
    // 		next({path: from.path})
    // 	}
    // } 
    
    if (to.meta.requireAuth && user.rolePathArray.indexOf(to.path) === -1) {//页面有权限要求但用户不符合
    	message.error('您没有此页面访问的权限！');
      document.title = to.meta.title
    	next('/login')
    	// if(from.path == '/login'){
      //   document.title = to.meta.title
    	// 	next('/login')
    	// }else{
      //   document.title = to.meta.title
    	// 	next({path: from.path})
    	// }
    } else if(to.matched.length === 0) {//页面没有权限要求就直接访问
      document.title = to.meta.title
      next({name:"error404"})//未匹配到的时候跳转到404页面
    } else if(!user.phone && to.path!='/userinfo' && to.path!='/changepassword' && to.path!='/login' && to.path!='/register' && to.path!='/forget') {
      message.error('请填写完整的个人资料~');
      next('/userinfo')
    } else {
      document.title = to.meta.title
    	next()
    }
  } else{//没有token的话让跳转到登录页，并传递当前准备访问的路由
    if(to.path=='/login' || to.path=='/register' || to.path=='/forget' || to.path=='/erweima' || to.path=='/prove'){
      document.title = to.meta.title
      next()
    }else{
      document.title = to.meta.title
      next('/login')
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js